export default "__VITE_ASSET__eLNTtpg8__"